module.exports = __webpack_public_path__ + "img/portrait-028.a4b1086a.jpg";